import { render, staticRenderFns } from "./input-box.vue?vue&type=template&id=5d4b5318&scoped=true&"
import script from "./input-box.vue?vue&type=script&lang=js&"
export * from "./input-box.vue?vue&type=script&lang=js&"
import style0 from "./input-box.vue?vue&type=style&index=0&id=5d4b5318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b5318",
  null
  
)

export default component.exports